export class ProjectUsersFromStringBuilderViewModel
{
    opened: boolean = false;
    operationInProgress: boolean = false;

    tags: string[] = [];

    show(tags: string[])
    {
        this.operationInProgress = false;
        this.tags = tags;

        this.opened = true;
    }

    close()
    {
        this.opened = false;

        this.tags = [];
        this.operationInProgress = false;
    }
}